module.exports = __webpack_public_path__ + "img/South Africa.bdffe88c.svg";